import { render, staticRenderFns } from "./StructureEditGroup.vue?vue&type=template&id=d5635964"
import script from "./StructureEditGroup.vue?vue&type=script&lang=js"
export * from "./StructureEditGroup.vue?vue&type=script&lang=js"
import style0 from "./StructureEditGroup.vue?vue&type=style&index=0&id=d5635964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports